import { render } from "./retail_room_card.vue?vue&type=template&id=1059ff94"
import script from "./retail_room_card.vue?vue&type=script&lang=js"
export * from "./retail_room_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__